<template>
  <div class="main-mine">
    <div class="sign_scan_code" @click="signScan" v-if="pageType === 1">
      <!-- 扫码签到 -->
      <van-icon name="scan" /><span>{{ $t('scan_signin') }}</span>
    </div>
    <i class="iconfont icon-icon_saoma" @click="startScan" v-else />
    <Overlay :show="scanning">
      <div><i class="iconfont icon-icon_wode_wodepeixun_kejianyulan_guanbi icon_scan" @click="closeScan" /></div>
      <div class="wrapper" @click.stop>
        <div class="block"></div>
      </div>
      <div class="user_scanner">{{ $t('qr_code_scanner') }}</div>
    </Overlay>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useThemeColor } from '@/utils/theme'
import { showToast, Overlay } from 'vant'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const scanning = ref(false)
const themeColor = useThemeColor()
const qrcodeStream = ref()

const props = defineProps({
  pageType: {
    type: Number,
    default: 1 // 1 培训签到 2 我的扫一扫
  },
  isExpired: {
    type: Boolean,
    default: false
  },
  isStart: {
    type: Boolean,
    default: false
  }
})

const startScan = () => {
  // scanning.value = true
  showToast(t('feature_not_supported'))
}

// 培训扫码签到
const signScan = () => {
  if (props.isExpired) {
    // 签到已过期
    showToast(t('signin_end'))
    return
  }
  if (props.isStart) {
    // 未开始
    showToast(t('signin_not_start'))
    return
  }
  // 暂时禁用
  showToast(t('feature_not_supported'))
  // scanning.value = true
}

const closeScan = () => {
  scanning.value = false
  qrcodeStream.value.stop()
}
</script>
<style scoped lang="less">
.main-mine {
  //background: #ccc;
  .iconfont {
    font-size: 24px;
  }
  :deep(.van-overlay) {
    background: rgba(0, 0, 0, 1);
    z-index: 9999;
  }
}
.sign_scan_code {
  position: relative;
  text-align: center;
  background: v-bind(themeColor);
  border-radius: 30px;
  padding: 19px 42px;
  width: fit-content;
  margin: 0 auto;
  color: #fff;
  span {
    margin-left: 6px;
  }
}

.wrapper {
  display: flex;
  justify-content: center;
  margin-top: 20%;
  height: 40%;
}

.block {
  width: 80%;
  background-color: #fff;
}
.user_scanner {
  color: #fff;
  text-align: center;
  margin-top: 32px;
}
:deep(.icon_scan) {
  color: #fff;
  padding: 16px;
  position: absolute;
  right: 10px;
}
</style>
